import { html } from '../utils';
export class SearchForm {
    openButton;
    closeButton;
    content;
    input;
    open;
    constructor(openButton, closeButton, content) {
        this.openButton = openButton;
        this.closeButton = closeButton;
        this.content = content;
        this.input = this.content?.querySelector('input');
        this.open = false;
        // Bind click
        const handleClick = this.handleClick.bind(this);
        this.openButton?.addEventListener('click', handleClick);
        this.closeButton?.addEventListener('click', handleClick);
        if (this.input) {
            this.input.addEventListener('keyup', (e) => {
                if (e.key === 'Enter') {
                    window.location = `${window.mainSiteData.searchResults}?keyword=${this.input?.value}`;
                }
            });
        }
    }
    handleClick() {
        this.updateGlobalClasses();
    }
    updateGlobalClasses() {
        if (this.open) {
            this.content.classList.add('animate-fade-out-up-25', 'pointer-events-none');
            this.content.classList.remove('animate-fade-in-down-25');
            html?.classList.remove('search-open');
            this.open = false;
        }
        else {
            this.content.classList.remove('animate-fade-out-up-25', 'pointer-events-none', 'hidden');
            this.content.classList.add('animate-fade-in-down-25');
            html?.classList.add('search-open');
            this.open = true;
        }
    }
}
